var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',_vm._b({attrs:{"value":_vm.progress}},'v-progress-linear',_vm.$attrs,false),[(_vm.showText)?_c('span',[_vm._v(_vm._s(_vm._f("number")(_vm.current / 1000,'0.0')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }